/* Photography for the Level 7 landing pages.
   ---------------------------------------------------------------------------
   Licensed via the Unsplash License (commercial use, no attribution required).

   EVERY image below has been downloaded and looked at, and only images that suit
   a UAE accounting / corporate-services audience are kept. That step is not
   optional: the ids recovered from the Level 7 mockup filenames included a
   lingerie fashion shoot sitting under "a real accountant on your side", and a
   beach-camel tourist shot captioned "Priced for the UAE, filed with the FTA".
   An HTTP 200 and a content-type of image/jpeg tell you a file exists — they
   tell you nothing whatsoever about what is in it.

   If you add an image here, download it and view it first. No exceptions.

   Sized and cropped by URL parameters so we ship one request per image at the
   size we actually render, instead of a multi-megabyte original. */

const UNSPLASH = 'https://images.unsplash.com';
const portrait = (id: string) => `${UNSPLASH}/${id}?w=900&q=80&auto=format&fit=crop&crop=faces`;
const wide = (id: string) => `${UNSPLASH}/${id}?w=1400&q=80&auto=format&fit=crop`;

export const L7_MEDIA = {
  /** Human-touch portrait on / and /accounting — professional, business attire. */
  accountingClient: portrait('photo-1573497019940-1c28c88b4f3e'),

  /** Corporate Services "a real PRO on your side" — blazer, tablet, charts, no face. */
  corporateClient: wide('photo-1628348068343-c6a848d2b6dd'),

  /** Home page human-touch — two advisers working through documents at a desk. */
  runComplyHuman: wide('photo-1600880292203-757bb62b4baf'),

  /** Architectural detail, monochrome — /corporate/pricing band. */
  dubaiArchitecture: wide('photo-1695390994823-eb74da2932c6'),

  /** Dubai's financial district — Emirates Towers with the Burj Khalifa behind.
      Used for the UAE bands on the pricing pages and How It Works. */
  dubaiBusinessDistrict: wide('photo-1600068485426-4d32cd411697'),

  /** Aerial coastline — /contact hero. */
  dubaiSkyline: wide('photo-1518684079-3c830dcef090'),

  /** Downtown Dubai by day — home-page video poster. */
  dubaiDowntown: wide('photo-1580674684081-7617fbf3d745'),

  /** Around a table, notes and coffee — /careers hero. */
  teamAtWork: wide('photo-1517048676732-d65bc937f952'),

  /** Overhead desk: laptop, notepad, phone — /careers values. */
  deskOverhead: wide('photo-1520607162513-77705c0f0d4a'),

  /** Glass-walled offices in the evening — /careers life here. */
  teamSession: wide('photo-1541746972996-4e0b0f43e02a'),
} as const;

/* ── Home-page video ───────────────────────────────────────────────────────
   TO TURN THE SECTION ON: paste the video URL into `url` below. That's the only
   change needed — a YouTube, Vimeo or direct .mp4 link all work, and the section
   appears on the home page immediately.

   It stays hidden while `url` is empty on purpose: a play button with nothing
   behind it is worse than no section at all. There is no Conncct video to point
   at yet (the YouTube channel @Conncct has no uploads, and the Level 7 mockups'
   "▶" turned out to be a decorative glyph on a section label, not a real embed). */
export const L7_VIDEO = {
  /* "A woman discussing to the team" — chosen by Khaled, so this one IS content-checked.
     Pexels License: free commercial use, no attribution, no release needed.
     1080p rendition rather than the 4K original — this is a landing page.
     https://www.pexels.com/video/a-woman-discussing-to-the-team-7792186/ */
  url: 'https://videos.pexels.com/video-files/7792186/7792186-hd_1920_1080_25fps.mp4',
  poster: L7_MEDIA.dubaiDowntown,
  eyebrow: 'Watch',
  title: 'See how it actually works.',
  lead: 'Two minutes on what we take off your desk, who does it, and what it costs.',
} as const;
